export default {"src":"/_next/static/media/playStore_135x40.c07ae674.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};